import React from 'react';
import {useTranslation} from 'react-i18next';

declare interface NotFoundProperties {
    message: string;
}

const NotFound = ({message}: NotFoundProperties): JSX.Element => {
    const {t} = useTranslation(['errors']);
    return (
        <div>
            <h1 className="title-large--light">{t('errors:notFound', 'Not Found')}</h1>
            <h2 className="subtitle-regular">{message}</h2>
        </div>
    );
};

export default NotFound;
